export const SiteLogo = ({className}) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="157" height="26" fill="none" viewBox="0 0 157 26">
      <path
        fill="#081B37"
        d="M100.879 6.456l-1.035-.164v-.885h3.33l3.661 5.384.743 1.517V6.456l-1.128-.164v-.885h3.397v.885l-1.009.164v8.342h-1.95l-3.887-5.776-.876-1.669v6.472l1.407.139v.834h-3.688v-.834l1.035-.139v-7.37zm12.28 7.508l1.021-.126V6.456l-.968-.177v-.872h2.044c.167 0 .348-.004.543-.013.203-.008.359-.017.464-.025.478-.034.885-.05 1.221-.05.946 0 1.698.088 2.254.265.558.168.96.438 1.209.809.256.362.385.842.385 1.44 0 .574-.16 1.109-.479 1.606-.318.497-.786.838-1.406 1.024.408.143.748.413 1.022.809.283.387.575.884.876 1.491.177.354.318.62.424.796.106.17.216.266.331.291l.385.114v.834h-2.52c-.134 0-.27-.135-.411-.404-.142-.27-.324-.691-.545-1.264-.274-.7-.512-1.239-.715-1.618-.195-.388-.411-.624-.651-.708h-1.194v3.034l1.18.126v.834h-4.47v-.834zm4.311-3.982c.461 0 .819-.168 1.075-.505.257-.346.385-.864.385-1.555 0-.607-.128-1.049-.385-1.327-.247-.287-.667-.43-1.26-.43-.319 0-.597.021-.836.063v3.716c.115.026.305.038.571.038h.45zm12.331 4.955c-1.485 0-2.587-.425-3.304-1.276-.715-.86-1.074-2.04-1.074-3.54 0-.969.185-1.815.558-2.54.38-.733.91-1.298 1.591-1.694.682-.396 1.478-.594 2.388-.594 1.521 0 2.64.404 3.356 1.213.726.8 1.089 1.947 1.089 3.438 0 .986-.19 1.858-.571 2.617-.38.75-.92 1.336-1.619 1.757-.69.413-1.494.62-2.414.62zm.119-8.81c-.637 0-1.132.333-1.485.999-.345.665-.517 1.66-.517 2.983 0 1.348.172 2.35.517 3.008.344.649.835.973 1.473.973.627 0 1.114-.354 1.459-1.061.353-.717.53-1.74.53-3.072 0-1.348-.168-2.321-.504-2.92-.336-.606-.828-.91-1.473-.91zm8.988.341l-.995-.176v-.885h4.523v.885l-1.26.176v7.344l2.495-.126.862-2.503 1.247.152-.385 3.463h-7.508v-.834l1.021-.126v-7.37zm11.152 0l-.995-.176v-.885h4.523v.885l-1.259.176v7.344l2.493-.126.863-2.503 1.246.152-.384 3.463h-7.509v-.834l1.022-.126v-7.37z"
      ></path>
      <path fill="#081B37" d="M96.578 24.407l-5.38-5.126H72.755l5.38 5.126h18.444z" opacity="0.3"></path>
      <path fill="#081B37" d="M91.2 1.953l5.378 5.126v17.573l-5.379-5.125V1.953z" opacity="0.6"></path>
      <path stroke="#FF8600" strokeWidth="0.174" d="M71.215 21.967v2.44"></path>
      <path fill="#FF8600" d="M70.84 21.817V0h22.976v21.817H70.84z"></path>
      <path
        fill="#fff"
        d="M79.582 6.498l-1.2-.205V5.268h8.408l.2 2.592h-1.214l-.538-1.48-3.028-.146v3.808l1.875-.044.277-1.201h1.06v3.676h-1.06l-.261-1.274-1.891-.044v3.983l3.366-.205.938-1.89 1.306.352-.369 2.753h-9.053v-.966l1.184-.146V6.498z"
      ></path>
      <path
        fill="#FF8600"
        d="M71.475 25.384c.425 0 .77-.327.77-.732 0-.404-.345-.732-.77-.732-.424 0-.768.328-.768.732 0 .405.344.732.769.732z"
      ></path>
      <path
        fill="#081B37"
        d="M5.628 15.123c-1.53 0-2.693-.421-3.489-1.264-.796-.851-1.194-2.014-1.194-3.489 0-.994.213-1.858.637-2.591a4.248 4.248 0 011.751-1.694c.743-.396 1.583-.594 2.52-.594.372 0 .73.021 1.075.063.345.034.761.085 1.247.152.38.059.642.093.783.101L8.8 8.626h-1.42l-.45-1.934c-.195-.202-.602-.303-1.221-.303-.681 0-1.22.324-1.619.973-.389.64-.583 1.584-.583 2.831 0 1.214.19 2.187.57 2.92.39.733.95 1.1 1.685 1.1.363 0 .637-.034.822-.101.195-.068.359-.165.491-.291l.597-1.353 1.3.114-.238 2.06c-.257.017-.57.08-.942.19-.354.093-.69.164-1.009.215-.31.05-.694.076-1.154.076zm11.145 0c-1.485 0-2.586-.426-3.303-1.277-.716-.86-1.074-2.039-1.074-3.539 0-.97.185-1.816.557-2.54.38-.734.91-1.298 1.592-1.694.68-.396 1.477-.594 2.388-.594 1.52 0 2.64.404 3.356 1.213.725.8 1.088 1.947 1.088 3.438 0 .986-.19 1.858-.57 2.616-.38.75-.92 1.336-1.62 1.758-.689.412-1.494.619-2.414.619zm.12-8.81c-.637 0-1.132.333-1.486.998-.345.666-.517 1.66-.517 2.983 0 1.349.172 2.351.517 3.009.345.649.836.973 1.473.973.628 0 1.114-.354 1.459-1.062.354-.716.53-1.74.53-3.071 0-1.349-.168-2.322-.503-2.92-.337-.607-.828-.91-1.473-.91zm8.987.341l-.995-.177v-.885h4.524v.885l-1.26.177v7.344l2.494-.127.862-2.502 1.247.152-.385 3.463H24.86v-.834l1.021-.127V6.654zm11.152 0l-.995-.177v-.885h4.524v.885l-1.26.177v7.344l2.494-.127.862-2.502 1.247.152-.385 3.463h-7.508v-.834l1.021-.127V6.654zm11.139 0l-1.035-.177v-.885h7.257l.172 2.238h-1.048l-.464-1.277-2.614-.126v3.286l1.619-.038.239-1.036h.915v3.172h-.915l-.226-1.1-1.632-.037v3.438l2.906-.177.809-1.63 1.128.303-.319 2.376H47.15v-.834l1.022-.127V6.654zm14.994 8.469c-.99 0-1.84-.207-2.547-.62a4.04 4.04 0 01-1.606-1.693c-.362-.716-.544-1.53-.544-2.44 0-1.045.208-1.934.624-2.667a3.98 3.98 0 011.778-1.656c.778-.379 1.698-.568 2.76-.568.61 0 1.215.042 1.817.126.6.084 1.11.173 1.525.265l-.159 2.44h-1.592L64.85 6.64c-.08-.084-.226-.155-.438-.214-.204-.068-.482-.102-.836-.102-.787 0-1.397.333-1.83.999-.434.657-.65 1.614-.65 2.87 0 1.246.18 2.237.543 2.97.372.724.946 1.087 1.725 1.087.318 0 .606-.038.862-.114.266-.084.464-.19.597-.316v-2.642l-1.234-.126v-.923h4.14v.923l-.664.1v3.325c-.15.009-.5.076-1.048.203-.54.134-1.026.24-1.46.316a7.302 7.302 0 01-1.392.126z"
      ></path>
    </svg>
  );
};

export const FormLoader = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
    <circle cx="40" cy="100" r="15" fill="#009FDE" stroke="#009FDE" strokeWidth="7">
      <animate
        attributeName="opacity"
        begin="-0.4"
        calcMode="spline"
        dur="1.5"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        values="1;0;1;"
      ></animate>
    </circle>
    <circle cx="100" cy="100" r="15" fill="#009FDE" stroke="#009FDE" strokeWidth="7">
      <animate
        attributeName="opacity"
        begin="-0.2"
        calcMode="spline"
        dur="1.5"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        values="1;0;1;"
      ></animate>
    </circle>
    <circle cx="160" cy="100" r="15" fill="#009FDE" stroke="#009FDE" strokeWidth="7">
      <animate
        attributeName="opacity"
        begin="0"
        calcMode="spline"
        dur="1.5"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        values="1;0;1;"
      ></animate>
    </circle>
  </svg>
);

export const OnlineLaptop = ({className}) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="31"
  height="30"
  fill="none"
  viewBox="0 0 31 30"
  className={className}
>
  <path
    fill="#1B3459"
    d="M25.813 5.625c.517 0 .937.42.937.938v14.062H4.25V6.562c0-.517.42-.937.938-.937h20.625zM5.188 3.75a2.813 2.813 0 00-2.813 2.813V22.5h26.25V6.562a2.813 2.813 0 00-2.813-2.812H5.188zM.5 23.438h30a2.813 2.813 0 01-2.813 2.812H3.313A2.813 2.813 0 01.5 23.437z"
  ></path>
  <path
    fill="#F0F3F9"
    d="M4.25 6a1 1 0 011-1h20.5a1 1 0 011 1v15.25H4.25V6z"
  ></path>
</svg>
);

export const CampusHouse = ({className}) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      stroke="#1B3459"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M22.001 10l-9.63-7.85c-.2-.08-.54-.08-.74 0L2.001 10c0 .55.45 1 1 1h18c.55 0 1-.45 1-1zM22.001 22h-20v-3c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v3zM3.999 18v-7M8.001 18v-7M12 18v-7M15.999 18v-7M20.001 18v-7M.999 22h22"
    ></path>
    <path
      stroke="#1B3459"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M12 8.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
    ></path>
  </svg>
);

export const GraduateHat = ({className}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
    <g clipPath="url(#clip0_4269_7787)">
      <path
        d="M10.7144 10.1673C7.6331 9.75183 4.55109 9.33648 1.46981 8.92096C4.088 7.06434 6.76578 5.37171 9.50203 3.77718C12.6474 4.14982 15.7886 4.56319 18.8675 5.09568C16.1878 6.80074 13.5074 8.50595 10.7142 10.1666L10.7144 10.1673Z"
        stroke="#1B3459"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.77534 9.50125C5.88972 11.1663 6.04916 12.8339 6.23201 14.5694C7.09435 15.4608 13.8788 16.4173 16.502 12.3038C15.9957 10.7194 15.492 9.13666 14.9865 7.55279"
        stroke="#1B3459"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.69466 13.0505C3.42713 11.7567 3.14952 10.3974 2.88525 9.11199C2.97618 9.05669 9.87575 6.95679 9.99082 6.92645"
        stroke="#1B3459"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.65493 18.0511C5.23386 16.777 4.81191 15.5024 4.39083 14.2283C4.38336 13.9075 4.39537 13.6502 4.29937 13.421C4.20337 13.1919 3.96633 13.0023 3.72079 13.0437C3.54463 13.0742 3.40235 13.2185 3.34442 13.387C3.28634 13.5548 3.30315 13.7414 3.35714 13.9111C3.4117 14.0799 3.50115 14.2353 3.57187 14.427C3.71399 15.7593 3.85611 17.0916 4.01394 18.459C4.57014 18.5307 5.14968 18.4059 5.65478 18.0504L5.65493 18.0511Z"
        stroke="#1B3459"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.57375 14.4388C3.85335 14.4015 4.12919 14.3357 4.39563 14.2432" stroke="#1B3459" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4269_7787">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MostPopular = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="28"
  fill="none"
  viewBox="0 0 24 28"
>
  <g clipPath="url(#clip0_11036_12330)">
    <ellipse cx="12" cy="11.202" fill="#FEC84B" rx="6" ry="5.6"></ellipse>
    <path
      fill="#046C3B"
      d="M24 11.41c0-.979-1.125-1.804-1.378-2.706-.263-.934.27-2.182-.228-3-.505-.83-1.913-1.012-2.62-1.685-.709-.673-.9-2.012-1.773-2.492-.86-.473-2.173.034-3.155-.216C13.896 1.07 13.03 0 12 0s-1.897 1.07-2.846 1.31c-.983.25-2.295-.256-3.155.217-.872.48-1.064 1.819-1.772 2.492s-2.116.856-2.62 1.685c-.498.818.034 2.066-.228 3C1.125 9.607 0 10.43 0 11.41c0 .979 1.125 1.804 1.379 2.707.262.934-.27 2.182.227 3 .505.828 1.913 1.01 2.62 1.684.709.674.9 2.012 1.773 2.492.86.473 2.173-.034 3.155.216.95.241 1.816 1.311 2.846 1.311s1.897-1.07 2.846-1.31c.983-.25 2.295.257 3.155-.217.872-.48 1.064-1.819 1.772-2.492s2.116-.855 2.62-1.685c.498-.817-.034-2.066.229-3C22.875 13.215 24 12.39 24 11.41zm-12 7.985c-4.63 0-8.398-3.582-8.398-7.985 0-4.403 3.767-7.985 8.398-7.985 4.63 0 8.398 3.582 8.398 7.985 0 4.403-3.767 7.985-8.398 7.985z"
    ></path>
    <path
      fill="#046C3B"
      d="M19.95 20.338c-.322.637-.686 1.36-1.45 1.78-.554.305-1.143.34-1.54.34-.268 0-.531-.018-.785-.036-.23-.016-.445-.032-.642-.032-.182 0-.323.013-.432.041a1.202 1.202 0 00-.21.08l3.33 5.486 1.582-3.732 4.189.564-3.333-5.49c-.07.046-.13.09-.178.137-.185.175-.361.525-.53.863l-.002-.001zM8.459 22.39c-.197 0-.413.016-.642.032-.254.018-.517.036-.785.036-.396 0-.986-.035-1.54-.34-.764-.42-1.128-1.142-1.45-1.78-.17-.338-.345-.687-.53-.863a1.198 1.198 0 00-.178-.135L0 24.83l4.19-.565 1.58 3.732 3.331-5.486a1.218 1.218 0 00-.21-.08 1.807 1.807 0 00-.432-.04zM11.997 4.863c-3.798 0-6.888 2.938-6.888 6.55 0 3.61 3.09 6.549 6.888 6.549s6.888-2.938 6.888-6.55c0-3.61-3.09-6.549-6.888-6.549zm4.646 5.33l-2.065 1.914a.215.215 0 00-.067.198l.487 2.701c.033.183-.168.321-.34.235l-2.551-1.275a.245.245 0 00-.219 0L9.337 15.24c-.172.086-.373-.052-.34-.235l.487-2.701a.216.216 0 00-.067-.198l-2.065-1.913c-.139-.13-.062-.354.13-.38l2.853-.395a.236.236 0 00.177-.122l1.276-2.458a.24.24 0 01.42 0l1.276 2.458c.034.066.1.112.177.122l2.853.394c.192.027.269.252.13.38h-.001z"
    ></path>
  </g>
  <defs>
    <clipPath id="clip0_11036_12330">
      <path fill="#fff" d="M0 0H24V28H0z"></path>
    </clipPath>
  </defs>
</svg>
);


export const PopularPrograms = ({className}) => (
<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
      className={className}
    >
      <g
        stroke="#1B3459"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_11036_12408)"
      >
        <path d="M9 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15zM9 12V9M9 6h.008"></path>
      </g>
      <defs>
        <clipPath id="clip0_11036_12408">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
);

export const Calendar = ({className}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" className={className}>
      <path
        stroke="#03A459"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M13.333 1.666v3.333M6.667 1.666v3.333M2.5 8.333h15m-13.333-5h11.666c.92 0 1.667.746 1.667 1.666v11.667c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.746-1.667-1.667V4.999c0-.92.746-1.666 1.667-1.666z"
      ></path>
    </svg>
  );
};

export const CollegeEnrollLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="181" height="30" fill="none" viewBox="0 0 181 30">
    <mask id="mask0_4244_768" style={{maskType: "luminance"}} width="181" height="30" x="0" y="0" maskUnits="userSpaceOnUse">
      <path fill="#fff" d="M180.632 0H0v30h180.632V0z"></path>
    </mask>
    <g mask="url(#mask0_4244_768)">
      <path
        fill="#fff"
        d="M113.18 7.45l-1.161-.19V6.239h3.736l4.107 6.213.834 1.75V7.449l-1.266-.19V6.24h3.812v1.02l-1.132.19v9.626h-2.188l-4.361-6.665-.983-1.925v7.467l1.578.16v.963h-4.137v-.962l1.161-.16V7.448zm13.778 8.662l1.145-.145V7.449l-1.086-.204V6.239h2.293c.188 0 .391-.005.609-.015.228-.01.403-.02.521-.03.536-.038.993-.057 1.37-.057 1.061 0 1.905.102 2.529.306.626.194 1.077.505 1.356.933.287.418.432.973.432 1.663 0 .661-.179 1.279-.537 1.852-.357.574-.883.968-1.577 1.182.457.165.838.476 1.146.933.318.447.645 1.02.982 1.721.199.408.357.715.476.919.12.194.243.306.371.335l.432.132v.962h-2.827c-.15 0-.302-.155-.461-.467-.159-.31-.363-.797-.611-1.458-.307-.807-.575-1.43-.803-1.867-.218-.447-.461-.72-.73-.817h-1.34v3.5l1.325.147v.962h-5.015v-.962zm4.836-4.594c.517 0 .919-.194 1.206-.583.289-.399.432-.997.432-1.794 0-.7-.143-1.21-.432-1.531-.277-.331-.748-.496-1.413-.496-.358 0-.671.024-.939.073v4.288c.13.029.343.043.641.043h.505zm13.835 5.718c-1.666 0-2.903-.492-3.707-1.474-.803-.991-1.205-2.353-1.205-4.083 0-1.118.208-2.096.626-2.932.426-.846 1.021-1.497 1.785-1.954.765-.457 1.658-.686 2.679-.686 1.707 0 2.962.467 3.766 1.4.814.924 1.221 2.247 1.221 3.968 0 1.137-.213 2.143-.64 3.019-.427.865-1.032 1.54-1.817 2.027-.774.476-1.677.715-2.708.715zm.133-10.166c-.714 0-1.27.384-1.666 1.152-.387.768-.58 1.916-.58 3.442 0 1.556.193 2.713.58 3.471.386.749.937 1.123 1.652 1.123.704 0 1.25-.408 1.637-1.225.397-.826.595-2.008.595-3.544 0-1.556-.188-2.679-.565-3.369-.378-.7-.929-1.05-1.653-1.05zm10.084.394l-1.116-.204V6.239h5.075v1.02l-1.414.205v8.474l2.799-.146.967-2.888 1.399.175-.432 3.996H154.7v-.962l1.146-.146V7.464zm12.512 0l-1.116-.204V6.239h5.074v1.02l-1.413.205v8.474l2.798-.146.968-2.888 1.398.175-.43 3.996h-8.426v-.962l1.147-.146V7.464z"
      ></path>
      <path fill="#fff" d="M108.352 28.162l-6.035-5.914H81.623l6.036 5.914h20.693z" opacity="0.3"></path>
      <path fill="#fff" d="M102.317 2.254l6.035 5.914v20.277l-6.035-5.914V2.254z" opacity="0.6"></path>
      <path stroke="#FF8600" strokeWidth="0.768" d="M79.9 25.348v2.816"></path>
      <path fill="#FF8600" d="M79.477 25.173V0h25.778v25.173H79.477z"></path>
      <path
        fill="#fff"
        d="M89.287 7.498L87.94 7.26V6.078h9.433l.224 2.991h-1.362l-.604-1.707-3.397-.169v4.394l2.104-.051.31-1.386h1.19v4.242h-1.19l-.293-1.47-2.12-.051v4.596l3.776-.236 1.052-2.18 1.465.405-.413 3.177H87.959v-1.115l1.328-.17v-9.85z"
      ></path>
      <path fill="#FF8600" d="M80.187 29.29a.854.854 0 00.863-.845.854.854 0 00-.863-.845.854.854 0 00-.862.845c0 .466.386.844.862.844z"></path>
      <path
        fill="#fff"
        d="M6.068 17.448c-1.717 0-3.022-.486-3.915-1.458-.893-.982-1.34-2.324-1.34-4.025 0-1.148.239-2.144.715-2.99A4.829 4.829 0 013.493 7.02c.833-.457 1.776-.685 2.828-.685.416 0 .818.024 1.205.073.387.039.854.097 1.4.175.426.068.719.107.877.117l-.178 3.252H8.032L7.526 7.72c-.218-.233-.675-.35-1.37-.35-.763 0-1.369.375-1.815 1.123-.437.74-.655 1.828-.655 3.267 0 1.4.213 2.524.64 3.37.437.845 1.067 1.268 1.89 1.268.407 0 .715-.039.923-.116.218-.078.402-.19.55-.336l.67-1.56 1.46.13-.269 2.378a4.9 4.9 0 00-1.056.219c-.397.107-.774.19-1.132.248a8.015 8.015 0 01-1.294.087zm12.504 0c-1.667 0-2.903-.49-3.706-1.473-.804-.991-1.206-2.353-1.206-4.083 0-1.118.208-2.096.625-2.932.427-.846 1.022-1.497 1.786-1.954.764-.457 1.657-.686 2.68-.686 1.706 0 2.961.467 3.765 1.4.814.924 1.22 2.246 1.22 3.968 0 1.137-.213 2.143-.64 3.018a4.853 4.853 0 01-1.816 2.028c-.773.476-1.676.714-2.708.714zm.134-10.165c-.715 0-1.27.384-1.667 1.152-.387.768-.58 1.915-.58 3.442 0 1.556.193 2.713.58 3.471.387.749.937 1.123 1.652 1.123.704 0 1.25-.408 1.637-1.225.397-.826.595-2.008.595-3.544 0-1.556-.188-2.679-.565-3.369-.377-.7-.928-1.05-1.652-1.05zm10.083.394l-1.117-.204V6.452h5.076v1.02l-1.414.205v8.473l2.798-.145.968-2.888 1.399.175-.432 3.996h-8.424v-.963l1.146-.145V7.677zm12.512 0l-1.117-.204V6.452h5.076v1.02l-1.414.205v8.473l2.798-.145.967-2.888 1.4.175-.432 3.996h-8.425v-.963l1.147-.145V7.677zm12.496 0l-1.16-.204V6.452h8.141l.194 2.581h-1.176l-.521-1.473-2.932-.146v3.792l1.815-.044.268-1.196h1.027v3.661h-1.027l-.253-1.269-1.83-.043v3.967l3.26-.204.907-1.882 1.265.35-.357 2.742h-8.767v-.963l1.146-.145V7.677zm16.823 9.771c-1.112 0-2.064-.238-2.858-.714a4.61 4.61 0 01-1.8-1.955c-.408-.826-.611-1.764-.611-2.814 0-1.206.233-2.232.7-3.078a4.519 4.519 0 011.994-1.91c.873-.438 1.905-.657 3.096-.657.684 0 1.364.049 2.039.146.675.097 1.245.2 1.711.306l-.178 2.815h-1.786l-.417-1.925c-.09-.097-.253-.18-.491-.248-.228-.078-.54-.117-.938-.117-.883 0-1.568.385-2.054 1.153-.486.758-.729 1.862-.729 3.31 0 1.44.203 2.582.61 3.428.417.836 1.062 1.254 1.935 1.254.357 0 .68-.044.968-.131.297-.097.52-.219.67-.365v-3.048l-1.385-.146v-1.065h4.644v1.065l-.744.117v3.836c-.169.01-.56.087-1.176.233-.605.155-1.151.277-1.637.365a7.968 7.968 0 01-1.563.145z"
      ></path>
    </g>
  </svg>
);

export const Facebook = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="22"
  height="22"
  fill="none"
  viewBox="0 0 22 22"
>
  <path
    fill="#96A2B3"
    d="M22.001 11.068c0-6.113-4.925-11.068-11-11.068C4.925 0 0 4.955 0 11.068 0 16.592 4.023 21.17 9.282 22v-7.734H6.489v-3.2h2.793V8.63c0-2.774 1.642-4.306 4.155-4.306 1.204 0 2.462.216 2.462.216v2.724h-1.387c-1.366 0-1.793.853-1.793 1.729v2.076h3.052l-.488 3.199H12.72V22C17.977 21.17 22 16.59 22 11.068z"
  ></path>
</svg>
);

export const Instagram = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="22"
  height="22"
  fill="none"
  viewBox="0 0 22 22"
>
  <path
    fill="#96A2B3"
    d="M11.001 0C8.014 0 7.639.013 6.465.066c-1.17.054-1.97.24-2.67.512a5.386 5.386 0 00-1.948 1.268 5.4 5.4 0 00-1.27 1.948c-.272.7-.458 1.5-.51 2.67C.013 7.638 0 8.013 0 11c0 2.988.013 3.361.066 4.535.054 1.17.24 1.97.512 2.67a5.39 5.39 0 001.268 1.948 5.385 5.385 0 001.948 1.27c.7.272 1.5.457 2.67.51C7.638 21.988 8.012 22 11 22c2.987 0 3.361-.013 4.534-.066 1.171-.054 1.972-.24 2.672-.511a5.38 5.38 0 001.947-1.27 5.4 5.4 0 001.27-1.948c.27-.7.456-1.5.51-2.67.053-1.173.067-1.547.067-4.535 0-2.987-.014-3.362-.067-4.536-.055-1.17-.24-1.97-.51-2.67a5.399 5.399 0 00-1.27-1.948A5.377 5.377 0 0018.205.578C17.504.305 16.704.12 15.533.066 14.36.013 13.986 0 10.998 0H11zm-.987 1.982h.987c2.937 0 3.285.01 4.445.064 1.072.049 1.655.228 2.042.378.514.2.88.438 1.264.823.385.385.624.752.824 1.265.15.387.33.97.378 2.042.053 1.16.065 1.508.065 4.444 0 2.935-.012 3.284-.065 4.443-.049 1.073-.228 1.655-.378 2.042-.2.513-.439.879-.824 1.264a3.4 3.4 0 01-1.264.822c-.387.152-.97.33-2.042.38-1.16.052-1.508.064-4.445.064-2.937 0-3.285-.012-4.445-.065-1.072-.049-1.655-.228-2.043-.379-.513-.2-.88-.438-1.265-.822a3.41 3.41 0 01-.823-1.265c-.15-.387-.33-.97-.379-2.042-.052-1.16-.063-1.508-.063-4.445 0-2.938.01-3.284.063-4.444.05-1.072.229-1.654.38-2.042.199-.513.437-.88.822-1.265a3.414 3.414 0 011.265-.823c.388-.152.97-.33 2.043-.38 1.015-.045 1.408-.06 3.458-.061v.002zm6.859 1.827a1.32 1.32 0 100 2.64 1.32 1.32 0 000-2.64zM11 5.35a5.65 5.65 0 100 11.299 5.65 5.65 0 000-11.299zm0 1.982a3.667 3.667 0 110 7.334 3.667 3.667 0 010-7.334z"
  ></path>
</svg>
);

export const CloseIcon = ({color = "white", className}) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <path d="M27 9L9 27M9 9L27 27" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
};


export const FilterIcon = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="none"
  viewBox="0 0 16 16"
>
  <path
    fill="#1B3459"
    stroke="#1B3459"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M14.665 2H1.332l5.333 6.307v4.36L9.332 14V8.307L14.665 2z"
  ></path>
</svg>
);

export const RightCheckedFilled = ({className}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" className={className}>
    <path fill="#03A459" d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z"></path>
    <path
      fill="#fff"
      d="M13.298 6.634a.833.833 0 011.189 1.167l-4.433 5.544a.833.833 0 01-1.2.022l-2.94-2.94A.834.834 0 117.09 9.25l2.327 2.325 3.859-4.916a.318.318 0 01.022-.025z"
    ></path>
  </svg>
);

export const FilterModalCloseIcon = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#1B3459"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M18 6L6 18M6 6l12 12"
  ></path>
</svg>
);


export const ForwardArrow = ({className}) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
  className={className}
>
  <path
    stroke="#fff"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    d="M4.168 10h11.667m0 0L10 4.165m5.834 5.833L10 15.833"
  ></path>
</svg>
);

export const Hamburger = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M21 12H7M21 6H3M21 18H3" stroke="#1B3459" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RightArrow = () => (
  <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.19922 1.69922L7.53609 7.69922L1.19922 13.6992" stroke="#FF8600" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const HeaderCloseIcon = ({className}) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="none"
  viewBox="0 0 16 16"
  className={className}
>
  <path
    fill="#081B37"
    fillRule="evenodd"
    d="M9.223 8l6.556-6.684a.776.776 0 00-.857-1.254.77.77 0 00-.249.17L8.13 6.905 1.315.222A.77.77 0 00.22.232a.776.776 0 00.01 1.094L7.036 8 .231 14.673a.776.776 0 00.535 1.326.77.77 0 00.549-.222l6.814-6.683 6.544 6.673a.771.771 0 001.095.01.776.776 0 00.012-1.094L9.223 7.999z"
    clipRule="evenodd"
  ></path>
</svg>
)

export const FilterDropDownArrow = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    stroke="#96A2B3"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.667"
    d="M5 7.5l5 5 5-5"
  ></path>
</svg>
)

export const ErrorIcon = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width={236}
  height={159}
  viewBox="0 0 236 159"
  fill="none"
>
  <path
      d="M148.642 25.4648H74.9454C71.7114 25.4648 69.0898 27.8204 69.0898 30.7263V151.74C69.0898 154.645 71.7114 157.001 74.9454 157.001H168.634C171.868 157.001 174.489 154.645 174.489 151.74V48.6899C174.489 47.2946 173.872 45.9561 172.774 44.9696L152.782 27.0059C151.684 26.0194 150.195 25.4648 148.642 25.4648Z"
      fill="#F8FAFD"
      stroke="#495D7A"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
  />
  <path
      d="M148.688 28.3164V43.6277C148.688 46.5336 151.309 48.8892 154.543 48.8892H171.583"
      fill="#F8FAFD"
  />
  <path
      d="M148.688 28.3164V43.6277C148.688 46.5336 151.309 48.8892 154.543 48.8892H171.583"
      stroke="#495D7A"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
  />
  <path
      d="M92.5156 121.891C108.685 107.362 134.9 107.362 151.07 121.891H92.5156Z"
      fill="#F8FAFD"
  />
  <path
      d="M92.5156 121.891C108.685 107.362 134.9 107.362 151.07 121.891"
      stroke="#495D7A"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
  />
  <path
      d="M92.5078 95.5875L108.049 81.623"
      stroke="#495D7A"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
  />
  <path
      d="M92.5078 81.623L108.049 95.5875"
      stroke="#495D7A"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
  />
  <path
      d="M135.523 95.5875L151.065 81.623"
      stroke="#495D7A"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
  />
  <path
      d="M135.523 81.623L151.065 95.5875"
      stroke="#495D7A"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
  />
  <path
      d="M4.24434 134.084C3.07708 134.084 1.98787 133.623 1.17895 132.779C0.394862 131.963 -0.0237905 130.889 0.0010448 129.754C0.0258801 128.619 0.487108 127.562 1.30313 126.779C2.09786 126.016 3.14094 125.598 4.24079 125.598C5.40805 125.598 6.49726 126.062 7.30618 126.903C8.92757 128.591 8.8708 131.282 7.182 132.903C6.38727 133.666 5.34419 134.084 4.24434 134.084ZM4.24434 126.587C3.39994 126.587 2.59811 126.91 1.99142 127.491C1.36344 128.094 1.00865 128.903 0.99091 129.775C0.973171 130.648 1.29248 131.47 1.89563 132.095C2.51296 132.74 3.35027 133.095 4.24789 133.095C5.09229 133.095 5.89411 132.772 6.5008 132.19C7.79579 130.949 7.83836 128.882 6.5966 127.587C5.97926 126.942 5.14196 126.587 4.24434 126.587Z"
      fill="#96A2B3"
  />
  <path
      d="M216.312 8.48634C215.184 8.46242 214.127 7.9984 213.342 7.18038C212.558 6.36236 212.137 5.28602 212.161 4.15706C212.185 3.02332 212.649 1.96611 213.467 1.18158C214.261 0.420968 215.308 0 216.418 0H216.489C217.623 0.0239187 218.68 0.487941 219.464 1.30596C220.249 2.12398 220.669 3.20032 220.646 4.32928C220.622 5.46302 220.158 6.52023 219.34 7.30476C218.546 8.06537 217.503 8.48634 216.403 8.48634H216.312ZM216.399 1.33466C215.643 1.33466 214.93 1.62169 214.385 2.14311C213.825 2.68367 213.505 3.40602 213.491 4.18098C213.476 4.96073 213.763 5.69742 214.299 6.25712C214.839 6.81682 215.562 7.13733 216.336 7.15168C217.14 7.15168 217.867 6.86466 218.407 6.34323C218.967 5.80267 219.287 5.08032 219.302 4.30536C219.316 3.53039 219.029 2.7937 218.493 2.22922C217.953 1.66952 217.231 1.34901 216.456 1.33466L216.394 0.971098V1.33466H216.399Z"
      fill="#96A2B3"
  />
  <path
      d="M31.4604 28.8868C32.8777 27.4748 32.8777 25.1854 31.4604 23.7734C30.0431 22.3613 27.7452 22.3613 26.3279 23.7734C24.9107 25.1854 24.9107 27.4748 26.3279 28.8868C27.7452 30.2988 30.0431 30.2988 31.4604 28.8868Z"
      fill="#96A2B3"
  />
  <path
      d="M233.926 131.037C234.922 130.045 234.922 128.436 233.926 127.443C232.93 126.451 231.315 126.451 230.319 127.443C229.323 128.436 229.323 130.045 230.319 131.037C231.315 132.03 232.93 132.03 233.926 131.037Z"
      fill="#96A2B3"
  />
</svg>
)


export const RefreshIcon = () => (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
  >
      <path
          d="M0.832031 3.33398V8.33398H5.83203"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
      />
      <path
          d="M2.9237 12.5C3.46403 14.0337 4.48814 15.3502 5.84174 16.2512C7.19535 17.1522 8.8051 17.5889 10.4285 17.4954C12.0518 17.402 13.6008 16.7835 14.8421 15.7332C16.0834 14.6828 16.9497 13.2575 17.3105 11.672C17.6714 10.0865 17.5071 8.42667 16.8426 6.94262C16.178 5.45857 15.0491 4.2307 13.6261 3.44401C12.203 2.65732 10.5628 2.35442 8.9526 2.58097C7.34241 2.80751 5.84946 3.55122 4.6987 4.70004L0.832031 8.33337"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
      />
  </svg>
)


export const RightArrowButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M4.16797 9.99935H15.8346M15.8346 9.99935L10.0013 4.16602M15.8346 9.99935L10.0013 15.8327"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
		<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#081B37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M9 12.5V9.5" stroke="#081B37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M9 6.5H9.00833" stroke="#081B37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);